import { render, staticRenderFns } from "./EditExtraVariable.vue?vue&type=template&id=68069c8c"
import script from "./EditExtraVariable.vue?vue&type=script&lang=js"
export * from "./EditExtraVariable.vue?vue&type=script&lang=js"
import style0 from "./EditExtraVariable.vue?vue&type=style&index=0&id=68069c8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports